jQuery(document).ready(function( $ ){
	// START JQUERY
	logit = (typeof logit !== 'undefined')? logit : false;

	// Copy to page - all options:
	// #
	//var filter_cards_enable = true;
	//var filter_cards_filter = false; // Search term
	//var filter_cards_hide = false; // Hide cards on filter - Enable or disable

	//var filter_cards_class = 'card-filter'; // Class for filter cards
	//var filter_cards_attribute = 'data-card-filter'; // Search value attribute
	//var filter_cards_class_active = 'active'; // Active class
	//var filter_cards_class_hidden = 'd-none'; // Hidden class
	//var filter_cards_class_disabled = 'opacity-25'; // Disabled class (when not hidden)

	filter_cards_enable = (typeof filter_cards_enable !== 'undefined')? filter_cards_enable : true; // Enable or disable function
	filter_cards_filter = (typeof filter_cards_filter !== 'undefined')? filter_cards_filter : false; // Search term
	filter_cards_hide = (typeof filter_cards_hide !== 'undefined')? filter_cards_hide : false; // Hide cards on filter - Enable or disable

	filter_cards_class = (typeof filter_cards_class !== 'undefined')? filter_cards_class : 'card-filter'; // Class for filter cards
	filter_cards_attribute = (typeof filter_cards_attribute !== 'undefined')? filter_cards_attribute : 'data-card-filter'; // Search value attribute
	filter_cards_class_active = (typeof filter_cards_class_active !== 'undefined')? filter_cards_class_active : 'active'; // Active class
	filter_cards_class_hidden = (typeof filter_cards_class_hidden !== 'undefined')? filter_cards_class_hidden : 'd-none'; // Hidden class
	filter_cards_class_disabled = (typeof filter_cards_class_disabled !== 'undefined')? filter_cards_class_disabled : 'opacity-25'; // Disabled class (when not hidden)

	var filter_cards_selector = '.' + filter_cards_class;

	// SCROLLSPY
	if(filter_cards_enable) {
		if(logit) console.log('[FILTER CARDS] Enabled ' + filter_cards_class);
  	if(logit == 2) console.log('[FILTER CARDS] Selectors: target: ' + filter_cards_selector + ', attribute: ' + filter_cards_attribute + ', active: ' + filter_cards_class_active + ', hidden: ' + filter_cards_class_hidden + ', disabled: ' + filter_cards_class_disabled);
		if(logit == 2) console.log('[FILTER CARDS] Options: filter: ' + filter_cards_filter + ', hide: ' + filter_cards_hide);

			function filterCards(filter=false) {
				if(filter) {
					if(logit) console.log('[FILTER CARDS] Filtering:' + filter);

					$(filter_cards_selector).each(function(){
							tags = $(this).attr(filter_cards_attribute);
							tags.replace(/\,$/, '');
							var tagsArr = tags.split(",");
							if(jQuery.inArray(filter,tagsArr) > -1){
								 $(this).addClass(filter_cards_class_active);
								 $(this).removeClass(filter_cards_class_hidden);
								 $(this).removeClass(filter_cards_class_disabled);
							} else {
								$(this).removeClass(filter_cards_class_active);
								if(filter_cards_hide)	$(this).addClass(filter_cards_class_hidden);
								$(this).addClass(filter_cards_class_disabled);
							}
					});



				} else {
					if(logit) console.log('[FILTER CARDS] Reseting!');
					$(filter_cards_selector).removeClass(filter_cards_class_active);
					$(filter_cards_selector).removeClass(filter_cards_class_hidden);
					$(filter_cards_selector).removeClass(filter_cards_class_disabled);
				}
			}



			if(filter_cards_filter) {
				filterCards(filter_cards_filter);
		 }

} else {
	if(logit == 3) console.log('[FILTER CARDS] Disabled');
}



	// END JQUERY
});
